import { useEffect, useState } from "react";

/**
 * Hook to detect if user prefers reduced motion
 * Returns true if user has prefers-reduced-motion: reduce set
 */
export function useReducedMotion() {
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
    setPrefersReducedMotion(mediaQuery.matches);

    const handleChange = (event: MediaQueryListEvent) => {
      setPrefersReducedMotion(event.matches);
    };

    mediaQuery.addEventListener("change", handleChange);
    return () => mediaQuery.removeEventListener("change", handleChange);
  }, []);

  return prefersReducedMotion;
}

/**
 * Helper to get appropriate motion config based on user preference
 */
export function getMotionConfig(prefersReducedMotion: boolean) {
  return {
    initial: prefersReducedMotion ? {} : undefined,
    animate: prefersReducedMotion ? {} : undefined,
    exit: prefersReducedMotion ? {} : undefined,
    transition: prefersReducedMotion ? { duration: 0 } : undefined,
  };
}
